module.exports = __webpack_public_path__ + "static/media/lock.6bc4bc6f.svg";